exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-delete-touch[data-v-58f1fff4]{display:none}@media (hover:none){.btn-delete-touch[data-v-58f1fff4]{display:block}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-58f1fff4","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/admin/js/shift-plan/modals/ShiftPlanModalForm.vue
// module id = jk+a
// module chunks = 0